module.exports = __webpack_public_path__ + "img/decrease_indent.c356acdd.svg";